'use client';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Target, Users, Lightbulb, Award, Phone, Mail } from 'lucide-react';
import { Header } from '@/components/shared/header';
import { Footer } from '@/components/shared/footer';
import { HeroSection } from '@/components/shared/hero-section';
import { CONTACT, DEFAULT_IMAGES } from '@/lib/constants';
import { TEAM_MEMBERS, TESTIMONIALS, COMPANY_VALUES, MILESTONES } from '@/lib/team-data';

export default function AboutPageClient() {


  const values = [
    {
      icon: Target,
      title: 'Ưu tiên giá trị kinh doanh',
      description: 'Công nghệ phải tạo ra giá trị kinh doanh thực tế.'
    },
    {
      icon: Target,
      title: 'Đổi mới lấy con người làm trung tâm',
      description: 'Con người là trung tâm của mọi đổi mới.'
    },
    {
      icon: Target,
      title: 'Sử dụng AI có trách nhiệm',
      description: 'AI phải minh bạch, an toàn và có trách nhiệm.'
    },
    {
      icon: Target,
      title: 'Quyết định dựa trên dữ liệu',
      description: 'Chúng tôi cam kết cung cấp những giải pháp chất lượng cao và hỗ trợ tuyệt vời.'
    },
    {
      icon: Target,
      title: 'Chất lượng là nền tảng',
      description: 'Chất lượng kỹ thuật là nền tảng của mọi giải pháp.'
    },
    {
      icon: Target,
      title: 'Học hỏi – Thử nghiệm – Mở rộng',
      description: 'Học hỏi nhanh, thử nghiệm nhanh và mở rộng dựa trên dữ liệu.'
    },
    {
      icon: Target,
      title: 'Tin cậy và Minh bạch',
      description: 'Minh bạch trong cam kết, trách nhiệm trong triển khai và đồng hành dài hạn với khách hàng.'
    },

  ];

  const teamMembers = [
    {
      id: 1,
      name: 'Nguyễn Văn A',
      position: 'Founder & CEO',
      department: 'Leadership',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=user1',
      bio: '10+ năm kinh nghiệm trong AI và công nghệ'
    },
    {
      id: 2,
      name: 'Trần Thị B',
      position: 'CTO - Giám Đốc Công Nghệ',
      department: 'Engineering',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=user2',
      bio: '8+ năm phát triển hệ thống AI'
    },
    {
      id: 3,
      name: 'Lê Minh C',
      position: 'Lead AI Engineer',
      department: 'AI/ML',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=user3',
      bio: 'Chuyên gia Machine Learning'
    },
    {
      id: 4,
      name: 'Phạm Hoàng D',
      position: 'Senior Software Engineer',
      department: 'Backend',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=user4',
      bio: 'Kiến trúc hệ thống phức tạp'
    }
  ];

  const milestones = [
    { year: '2021', event: 'Thành lập công ty MachineAI' },
    { year: '2022', event: 'Phát triển sản phẩm MachineAI Workspace' },
    { year: '2023', event: 'Phát triển Local AI, có 50+ dự án' },
    { year: '2024', event: 'Mở rộng đội ngũ, cung cấp dịch vụ 24/7 toàn cầu' }
  ];

  return (
    <>

      {/* Mission & Vision Section */}
      <section className="px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-12 lg:grid-cols-2">
            <div className="bg-white border border-slate-200 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-foreground mb-4">TẦM NHÌN</h2>
              <p className="text-muted-foreground text-lg leading-relaxed">Trở thành đối tác công nghệ đáng tin cậy giúp doanh nghiệp vận hành hiệu quả hơn, ra quyết định nhanh hơn và tạo ra lợi thế cạnh tranh bền vững trong kỷ nguyên AI.</p>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-foreground mb-4">SỨ MỆNH</h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                Ứng dụng sức mạnh của AI, dữ liệu và kỹ thuật phần mềm kết hợp kiến thức quản trị để giải quyết các bài toán thực tiễn của doanh nghiệp. Cung cấp các giải pháp công nghệ chất lượng cao, giúp khách hàng tối ưu chi phí, nâng cao hiệu quả vận hành và thúc đẩy đổi mới sáng tạo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="px-4 py-20 sm:px-6 lg:px-8 bg-slate-50">
        <div className="mx-auto max-w-7xl">
          <div className="mb-16 text-center">
            <h2 className="text-4xl font-bold text-foreground mb-4">Giá Trị Cốt Lõi</h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Những nguyên tắc mà chúng tôi hướng tới trong mọi công việc
            </p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((value, idx) => {
              const Icon = value.icon;
              return (
                <div key={`values-${idx}`} className="bg-white border border-slate-200 rounded-xl p-6">
                  <Icon className="h-8 w-8 text-primary mb-4" />
                  <h3 className="text-lg font-bold text-foreground mb-2">{value.title}</h3>
                  <p className="text-muted-foreground text-sm">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-16 text-center">
            <h2 className="text-4xl font-bold text-foreground mb-4">Đội Ngũ Của Chúng Tôi</h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Những chuyên gia tận tâm đồng hành với bạn trên hành trình số hóa
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="bg-white border border-slate-200 rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 flex flex-col"
              >
                <div className="mb-4 flex justify-center">
                  <div className="w-20 h-20 rounded-full overflow-hidden border-3 border-primary/20">
                    <img
                      src={member.avatar}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <h3 className="text-lg font-bold text-foreground mb-1">{member.name}</h3>
                <p className="text-primary font-semibold text-sm mb-2">{member.position}</p>

                <Badge className="justify-center mb-3 bg-blue-50 text-primary hover:bg-blue-100 w-max mx-auto">
                  {member.department}
                </Badge>

                <p className="text-muted-foreground text-sm leading-relaxed flex-grow">
                  {member.bio}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Timeline Section */}
      {/* <section className="px-4 py-20 sm:px-6 lg:px-8 bg-slate-50">
        <div className="mx-auto max-w-4xl">
          <div className="mb-16 text-center">
            <h2 className="text-4xl font-bold text-foreground mb-4">Hành Trình Của Chúng Tôi</h2>
          </div>

          <div className="space-y-8">
            {milestones.map((milestone, idx) => (
              <div key={idx} className="flex gap-8 items-start">
                <div className="flex flex-col items-center">
                  <div className="bg-primary text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-sm">
                    {milestone.year.slice(-2)}
                  </div>
                  {idx < milestones.length - 1 && <div className="border-l-2 border-primary h-16 my-2" />}
                </div>
                <div className="bg-white border border-slate-200 rounded-lg p-6 flex-1">
                  <p className="text-primary font-bold mb-1">{milestone.year}</p>
                  <p className="text-muted-foreground">{milestone.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Why Choose Us Section */}
      {/* <section className="px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-16 text-center">
            <h2 className="text-4xl font-bold text-foreground mb-4">Tại Sao Chọn MachineAI?</h2>
          </div>

          <div className="grid gap-8 sm:grid-cols-1 lg:grid-cols-2">
            {[
              {
                title: 'Chuyên Gia Trong Lĩnh Vực',
                description: 'Đội ngũ gồm những kỹ sư và chuyên gia hàng đầu với kinh nghiệm 10+ năm trong AI, tự động hóa và đám mây.'
              },
              {
                title: 'Giải Pháp Toàn Diện',
                description: 'Từ tư vấn, phát triển, triển khai đến hỗ trợ 24/7, chúng tôi cung cấp giải pháp từ A-Z.'
              },
              {
                title: 'Bảo Mật Dữ Liệu Tối Đa',
                description: 'Chúng tôi cung cấp các giải pháp 100% offline Local AI với bảo mật dữ liệu tuyệt đối.'
              },
              {
                title: 'Hỗ Trợ Liên Tục',
                description: 'Đội hỗ trợ 24/7 sẵn sàng giúp bạn mọi lúc, từ triển khai đến tối ưu hóa hệ thống.'
              }
            ].map((reason, idx) => (
              <div key={idx} className="bg-white border border-slate-200 rounded-xl p-8">
                <div className="flex items-start gap-4 mb-4">
                  <CheckCircle2 className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
                  <h3 className="text-xl font-bold text-foreground">{reason.title}</h3>
                </div>
                <p className="text-muted-foreground">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="px-4 py-20 sm:px-6 lg:px-8 bg-slate-50">
        <div className="mx-auto max-w-3xl">
          <div className="bg-blue-50 border-2 border-primary rounded-2xl p-12 text-center">
            <h2 className="text-3xl font-bold text-foreground mb-4">Hãy Cùng Chúng Tôi Bắt Đầu</h2>
            <p className="text-muted-foreground text-lg mb-8">
              Liên hệ với chúng tôi ngay hôm nay để tìm hiểu cách chúng tôi có thể giúp doanh nghiệp của bạn phát triển
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button className="bg-primary text-white hover:bg-primary/90 flex items-center justify-center gap-2">
                <Mail className="h-4 w-4" />
                Yêu Cầu Tư Vấn
              </Button>
              <Button variant="outline" className="border-primary text-primary hover:bg-primary/10 flex items-center justify-center gap-2">
                <Phone className="h-4 w-4" />
                {CONTACT.phone}
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
